import { Dropdown, Option, makeStyles, tokens } from '@fluentui/react-components';
import { useEffect } from 'react';
import { AgentSelectListItem, SuperAgentName } from '../../libs/services/AgentService';
import { useChat } from '../../libs/hooks';
import { useAppDispatch } from '../../redux/app/hooks';
import { setSelectedConversation } from '../../redux/features/conversations/conversationsSlice';

const useClasses = makeStyles({
    dropdown: {
        minWidth: '180px',
        margin: tokens.spacingVerticalM,
    },
});

interface AgentListProps {
    selectedAgentId: string;
    setSelectedAgentId: (id: string) => void;
    agents: AgentSelectListItem[];
}

export const AgentList: React.FC<AgentListProps> = ({ selectedAgentId, setSelectedAgentId, agents }) => {
    const classes = useClasses();
    const chat = useChat();
    const dispatch = useAppDispatch();

    useEffect(() => {
        // Sadece agents yüklendiğinde ve selectedAgentId boşsa ilk agent'ı seç
        if (agents.length > 0 && !selectedAgentId) {
            setSelectedAgentId(agents[0].value);
        }
    }, [agents, selectedAgentId, setSelectedAgentId]);

    const handleChange = (_ev: any, data: import('@fluentui/react-components').OptionOnSelectData) => {
        const value = data.optionValue as string;
        setSelectedAgentId(value);

        // Agent değişikliği sırasında seçili conversation'ı temizle
        dispatch(setSelectedConversation(''));

        void chat.loadChats(value);
    };

    const selectedAgent = agents.find((item) => item.value === selectedAgentId);

    // Tek agent var ve o da SuperAgent ise dropdown'ı gizle.
    // Diğer tüm durumlarda (birden fazla agent, veya tek bir alt-agent) dropdown görünür.
    if (agents.length === 1 && agents[0].name === SuperAgentName) {
        return null;
    }

    return (
        <Dropdown
            className={classes.dropdown}
            placeholder="Bir agent seçin"
            selectedOptions={selectedAgentId ? [selectedAgentId] : []}
            value={selectedAgent?.text ?? ''}
            onOptionSelect={handleChange}
        >
            {agents.map((item) => (
                <Option key={item.value} value={item.value}>
                    {item.text}
                </Option>
            ))}
        </Dropdown>
    );
};
